// @packages
import PropTypes from 'prop-types';
import React from 'react';

// @scripts
import CtrlMainMenu from '../controls/master-page/ctrl-main-menu';

const CtrlRestrictedControls = ({
    currentUrl,
    mainMenuProps
}) => (
    <CtrlMainMenu
        currentUrl={currentUrl}
        id="ctrl-main-menu"
        isExpanded={mainMenuProps.isExpanded}
        onCollapse={mainMenuProps.onCollapse}
        onExpand={mainMenuProps.onExpand}
        key="ctrl-main-menu"
        visible
    />
);

CtrlRestrictedControls.propTypes = {
    currentUrl: PropTypes.string.isRequired,
    mainMenuProps: PropTypes.shape({
        isExpanded: PropTypes.bool.isRequired,
        onCollapse: PropTypes.func.isRequired,
        onExpand: PropTypes.func.isRequired
    }).isRequired
};

export default CtrlRestrictedControls;
